import { Checkbox } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import useWeekDays from 'src/Hooks/CalendarLogic/useWeekDays';
import { TransformValues } from 'src/types/transform-values.type';
import getNestedValue from 'src/Utils/getNestedValue';

import styles from './EventCreationWeekDayPicker.module.scss';
import { Props } from './EventCreationWeekDayPicker.types';

const EventCreationWeekDayPicker = <T, O extends TransformValues<T>>({
  form,
  pathWeekDays = 'recurrence.byWeekDays',
}: Props<T, O>) => {
  const { t } = useTranslation();
  const weekDays = useWeekDays();

  const weekDaysValue = getNestedValue(form.values, pathWeekDays) || [];

  return (
    <div className={styles.container}>
      <div className={styles.label}>{t('createEventForm.the', 'Le')}</div>
      <div className={styles.days}>
        {weekDays.map(weekDay => {
          const toggleWeekDay = (checked?: boolean) => {
            const selectedWeekDays = weekDaysValue;
            const isCurrentlySelected =
              checked ?? selectedWeekDays.includes(weekDay.rruleIndex.toString());

            const newWeekDays = !isCurrentlySelected
              ? [...selectedWeekDays, weekDay.rruleIndex.toString()]
              : selectedWeekDays.filter((m: string) => m !== weekDay.rruleIndex.toString());

            form.setFieldValue(pathWeekDays, newWeekDays);
          };

          return (
            <Checkbox
              key={weekDay.fullName}
              label={weekDay.shortName}
              className={styles.checkbox}
              checked={weekDaysValue.includes(weekDay.rruleIndex.toString())}
              onChange={event => toggleWeekDay(event.currentTarget.checked)}
              wrapperProps={{
                onClick: () => toggleWeekDay(),
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default EventCreationWeekDayPicker;
